module.exports = __webpack_public_path__ + "img/80.d84eb8bc.jpg";